<template>
  <div class="flex-row flex-wrap justify-start align-start max-height-collision-targets">
    <toy-from-component class="p-2" v-for='transformsAndSource in transformsAndSources' :key='transformsAndSource.c.id' :transforms-and-source='transformsAndSource'  />
  </div>
</template>

<script>
import { fromPairs, toPairs } from 'lodash';
import { abstractField } from "vue-form-generator";
import ToyFromComponent from '@edit/molecules/ToyFromComponent.vue';
export default {
  mixins: [ abstractField ],
  data() {
    const {partutil} = this.vfg.schema.data;

    const filterComponentTypes = this.schema.filterComponentTypes;
    const filter = partutil.gamedata.filterComponentsByType(filterComponentTypes);
    const sources = partutil.gamedata.findComponentsAndSourceByFilter(filter);
    const transformsAndSources = partutil.gamedata.findTransformsAndSourceForComponentsAndSource(sources)
      .filter( ({c}) => {
        return this.value.indexOf(c.id) !== -1;
      });


    return {
      transformsAndSources,
    }
  },
  components:{
    ToyFromComponent
  },
  methods: {
  },
  watch: {
    selections: {
      handler(nv) {
        this.value = Object.keys(fromPairs(toPairs(nv).filter( ([key,value]) => {
          return value;
        })));
      },
      deep: true
    }
  },
}
</script>
<style scoped>
.max-height-collision-targets {
  max-height:80px;
  overflow-y:auto;
}
</style>
